import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import React from "react";

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  "& .MuiDialogTitle-closeButton": {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const CustomDialogTitle = ({ children, onClose, ...other }) => {
  return (
    <StyledDialogTitle {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </StyledDialogTitle>
  );
};

CustomDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
};

function Modal({
  open,
  title,
  children,
  handleClose,
  handleSubmit,
  closeTitle,
  submitTitle,
  disabled,
  overwriteActions,
  dialogActionStyles,
  maxWidth,
  dialogContentStyles,
  variantClose,
  variantSubmit,
}) {
  function renderDefaultActions() {
    return (
      <div>
        <Button
          onClick={handleClose}
          variant={variantClose || "text"}
          color="primary"
          style={{ paddingRight: "15px" }}
        >
          {closeTitle}
        </Button>

        <Button
          onClick={handleSubmit}
          variant={variantSubmit || "text"}
          color="primary"
          disabled={disabled}
          style={{ paddingLeft: "15px" }}
        >
          {submitTitle}
        </Button>
      </div>
    );
  }

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      fullWidth
      maxWidth={maxWidth}
    >
      <CustomDialogTitle onClose={handleClose}>{title}</CustomDialogTitle>

      <DialogContent style={dialogContentStyles}>{children}</DialogContent>

      <DialogActions style={dialogActionStyles}>
        {overwriteActions ? overwriteActions() : renderDefaultActions()}
      </DialogActions>
    </Dialog>
  );
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  disabled: PropTypes.bool,
  overwriteActions: PropTypes.func,
  closeTitle: PropTypes.string,
  submitTitle: PropTypes.string,
  handleSubmit: PropTypes.func,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  dialogContentStyles: PropTypes.object,
  dialogActionStyles: PropTypes.object,
  variantClose: PropTypes.oneOf(["contained", "outlined", "text"]),
  variantSubmit: PropTypes.oneOf(["contained", "outlined", "text"]),
};

export default Modal;
